import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  errors: {},
  touched: {},
  isSubmitting: false,
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setFieldError: (state, action) => {
      const { field, error } = action.payload;
      if (error) {
        state.errors[field] = error;
      } else {
        // Use Immer's delete pattern
        const newErrors = { ...state.errors };
        delete newErrors[field];
        state.errors = newErrors;
      }
    },
    setFieldErrors: (state, action) => {
      state.errors = action.payload;
    },
    clearFieldError: (state, action) => {
      const field = action.payload;
      const newErrors = { ...state.errors };
      delete newErrors[field];
      state.errors = newErrors;
    },
    clearAllErrors: (state) => {
      state.errors = {};
      state.touched = {};
    },
    setFieldTouched: (state, action) => {
      const { field, touched } = action.payload;
      state.touched[field] = touched;
    },
    setSubmitting: (state, action) => {
      state.isSubmitting = action.payload;
    },
  },
});

export const {
  setFieldError,
  setFieldErrors,
  clearFieldError,
  clearAllErrors,
  setFieldTouched,
  setSubmitting,
} = formSlice.actions;

export default formSlice.reducer;

